<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>상품안내</li>
        <li>적하보험의 가입대상</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>적하보험의 가입대상</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>적하보험의 가입대상</span>
          </button>
          <ul>
            <li>
              <router-link to="/insursumCargoidm"
                ><span>적하보험의 개요</span></router-link
              >
            </li>
            <li>
              <router-link to="/cargotarProdguid"
                ><span>적하보험의 가입대상</span></router-link
              >
            </li>
            <li>
              <router-link to="/condcovProdguid"
                ><span>조건별 담보안내</span></router-link
              >
            </li>
            <li>
              <router-link to="/insurstrtProdguid"
                ><span>보험의 개시와 종료</span></router-link
              >
            </li>
            <li>
              <router-link to="/premcalProdguid"
                ><span>보험료 산출 및 납입</span></router-link
              >
            </li>
            <li>
              <router-link to="/blaninsurProdguid"
                ><span>포괄보험 안내</span></router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="conStyle2">
          <div class="imgWrap">
            <img src="@/assets/images/imgPdtInfo2.png" alt="" />
          </div>

          <div class="txtWrap">
            <p class="tit">
              선박이나 항공기 등으로<br />
              운송되는 <span class="fcRed">국내외 운송화물</span><br />
              일체 가입 가능
            </p>
            <p class="txt">
              항공기나 선박을 이용하여 운송되는 수출/입 화물 및 국내 연안
              운송화물<br />
              일체가 적하보험의 가입 대상이 되며 삼국간 운송화물과 컨테이너
              보험을<br />
              포함합니다.<br />

              단, 방위산업관련 화물에 대한 적하보험 계약은 현행 해상 및
              보세보험<br />
              공동인수 협정에 의거 대한 손해보험 협회에서 이를 일괄 인수토록
              되어 있으므로,<br />
              일반 보험 회사에서는 인수할 수 없습니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
</script>

<style></style>
